import React from "react";
import * as dc from "dc";
import * as d3 from 'd3';
import { ChartTemplate } from "./chartTemplate";

//const self = this;
const barChartFunc = (divRef, ndx) => {
    //console.log('dim '+this.props.dim)
    const myChart = dc.rowChart(divRef);

    const dimension = ndx.dimension(function (d) {
      return d.activity_type;
    });

   const group = dimension.group().reduce(
    function(p, v) { // add
      ++p.count;
      if(p.count > 0) {
        p.totalWords += v.n_of_words;
        p.avgWords = Math.floor(parseFloat(100*p.totalWords/p.count))/100;
        p.totalVocabulary += v.vocabulary_used;
        p.avgVocabulary = Math.floor(parseFloat(100*p.totalVocabulary/p.count))/100;
        // if(p.ids.indexOf(v.project_id) > -1){
        if(v.project_id in p.p_ids){
          p.p_ids[v.project_id] += 1
        }
        else{
            p.p_ids[v.project_id] = 1;
            p.id_count++;
        }
        //p.assignements += v.id_count;
        // p.totStudennts = (p[v.student] || 0) + v.counter;
        // p.students = Math.floor(parseFloat(100*p.totStudennts/p.count))/100;
        // p.tot_conversation_time +=  Math.floor(parseFloat(v.conversation_time));
        // p.avg_conversation_time =  Math.floor(parseFloat(100*p.tot_conversation_time/p.count))/100;
      }
      else {
        p.avgWords = 0;
        p.totalWords = 0;
        p.totalVocabulary = 0;
        p.avgVocabulary = 0;
        p.id_count = 0;
        p.p_ids = {};
        //p.assignements = 0;
        // p.totStudennts = 0;
        // p.students = 0;
        // p.tot_conversation_time = 0;
        // p.avg_conversation_time = 0;
      }
      return p;
    },
    function(p, v) { // remove
      --p.count;
      if(p.count > 0) {
        p.totalWords -= v.n_of_words;
        p.avgWords = Math.floor(parseFloat(100*p.totalWords/p.count))/100;
        p.totalVocabulary -= v.vocabulary_used;
        p.avgVocabulary = Math.floor(parseFloat(100*p.totalVocabulary/p.count))/100;
        // if(p.ids.indexOf(v.project_id) > -1){
        if(v.project_id in p.p_ids){
          p.p_ids[v.project_id] -= 1
        }
        if(p.p_ids[v.project_id] === 0){
            delete p.p_ids[v.project_id];
            p.id_count--;
        }
        //p.assignements -= v.id_count;
        // p.totStudennts = (p[v.student] || 0) - v.counter;
        // p.students = Math.floor(parseFloat(100*p.totStudennts/p.count))/100;
        // p.tot_conversation_time -=  Math.floor(parseFloat(v.conversation_time));
        // p.avg_conversation_time =  Math.floor(parseFloat(100*p.tot_conversation_time/p.count))/100;
      }
      else {
        p.avgWords = 0;
        p.totalWords = 0;
        p.totalVocabulary = 0;
        p.avgVocabulary = 0;
        p.id_count = 0;
        p.p_ids = {};
        // p.assignements = 0;
        // p.totStudennts = 0;
        // p.students = 0;
        // p.tot_conversation_time = 0;
        // p.avg_conversation_time = 0;
      }
      return p;
    },
    function() { // init
        return {count: 0, totalWords: 0, avgWords: 0, totalVocabulary: 0, avgVocabulary: 0, id_count: 0, p_ids: {}};
    }
  );

  const size = group.size();
  const barHeight = 18;
  let LabelPadding = 0;

    myChart
    .dimension(dimension)
    .group(group)
    .valueAccessor(function (p) {
       return p.value.count ;
     })
     //.ordering(function(d){ return d.value.count})
    .elasticX(true)
    //.elasticY(true)
    .margins({ top: 5, right: 30, bottom: 25, left: 100 })
    .labelOffsetX(-100)
    .height(30 + size*(barHeight+2))
    .gap(2)
    .colors(["#065FE5"])
    .transitionDuration(1000)
    .title(function(d) {
      return d3.format(",d")(d.value.count); // or your custom value accessor
    })
    .renderTitleLabel(true)
    .fixedBarHeight(barHeight)
    .xAxis().ticks(6);

    myChart.on('pretransition', function(chart) {
      const padding = 10;
      const maxWidth = chart.effectiveWidth();

      const label = chart.selectAll('g.row > text:nth-child(3)'); //find all row labels
      label.attr('x', padding) //move labels to starting position

      .transition() //start transition
      .duration(chart.transitionDuration()) //use chart's transitionDuration so labels animate with rows
      .attr('x', function(d){ //set label final position
          var dataValue = chart.valueAccessor()(d); //use chart's value accessor as basis for row label position
          var scaledValue = chart.xAxis().scale()(dataValue); //convert numeric value to row width
          if(scaledValue < 20) {
            d.LabelPadding = padding;
            return  padding;
          }
          d.LabelPadding = scaledValue - padding;
          return scaledValue - padding; //return scaled value to set label position
      })
      label.classed('label_text',function(d) {
        if(d.LabelPadding <= padding)
          return false;
        else return true;
      })
      label.classed('label_text1',function(d) {
        if(d.LabelPadding > padding)
          return false;
        else return true;
      })

      // const row = chart.selectAll('g.row > rect')
      // row.attr('x', function(d){ //set label final position
      //     var dataValue = chart.valueAccessor()(d); //use chart's value accessor as basis for row label position
      //     var scaledValue = chart.xAxis().scale()(dataValue);
      //     return (maxWidth - scaledValue)/2
      // })

    });

    return myChart
}

export const Activities = props => (
  <ChartTemplate chartFunction={barChartFunc} title={props.title} dim={props.dim} metric={props.metric} type={props.type}
    showMetricsSelector={props.showMetricsSelector} reset={false}/>
)
